import JobTitleList from './Request/JobTitle_list';

const mapJobTitleList = jobTitlelist => {
  if (!jobTitlelist) return [];
  return jobTitlelist.map(jobTitle => [
    jobTitle.name,
    jobTitle.Department.name,
    jobTitle.numberOfEmployees,
    jobTitle.numberOfCourses,
    jobTitle.status ? 'Activo' : 'Inactivo',
    jobTitle.departmentId,
    jobTitle.id,
  ]);
};

const fetch = async () => {
  const jobTitles = await JobTitleList({ statusFilter: 'ACTIVE' });
  const jobTitleList = mapJobTitleList(jobTitles);
  return { jobTitleList };
};

export default fetch;
